import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css'; // optional
import {Link} from '@chakra-ui/react'

export const Tooltip = (props) => (
  <Tippy content={<Link href={props.link}><em>{props.label}</em></Link>} {...props}>
    <button>{props.children}</button>
  </Tippy>
)